import HttpService from "./htttp.service";

class ResponseRequirementsService {
  // ResponseRequirementsEndpoint = process.env.API_URL;

  getPerClientResponseRequirements = async (clientId) => {
    const getPerClientResponseRequirements = "dash/response_requirements";
    return await HttpService.get(getPerClientResponseRequirements, clientId);
  };

  getSingleResponseRequirements = async (id) => {
    const getSingleResponseRequirements = `dash/response_requirements/${id}`;
    return await HttpService.get(getSingleResponseRequirements);
  };

  createResponseRequirements = async (payload) => {
    const createResponseRequirements = "dash/response_requirements/new";
    return await HttpService.post(createResponseRequirements, payload);
  };

  editResponseRequirements = async (id, payload) => {
    const editResponseRequirements = `dash/response_requirements/${id}`;
    return await HttpService.put(editResponseRequirements, payload);
  };

  deleteResponseRequirements = async (id, payload) => {
    const deleteResponseRequirements = `dash/response_requirements/${id}`;
    return await HttpService.delete(deleteResponseRequirements, payload);
  };
}

export default new ResponseRequirementsService();
